function formatPostalCode(input) {
  if (!input) return ''

  const preformattedValue = input.toUpperCase().replace(/ /g, '')

  const regex = /^[A-Z][0-9][A-Z][0-9][A-Z][0-9]|^[A-Z][0-9][A-Z][0-9][A-Z]|^[A-Z][0-9][A-Z][0-9]|^[A-Z][0-9][A-Z]|^[A-Z][0-9]|^[A-Z]/
  const match = preformattedValue.match(regex)

  if (match) {
    return match[0].length > 3 ? match[0].substring(0, 3) + ' ' + match[0].substring(3) : match[0]
  }

  return ''
}

function formatMonth(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

function formatDateInput(input) {
  if (!input) return ''

  const preformattedValue = input.toUpperCase().replace(/ /g, '').replace(/-/g, '')

  const regex = new RegExp(
    '^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([0-9]{0,6})' +
      '|^(Jan?|Feb?|Mar?|Apr?|May?|Jun?|Jul?|Aug?|Sep?|Oct?|Nov?|Dec?)' +
      '|^(Ja?|Fe?|Ma?|Ap?|Ma?|Ju?|Ju?|Au?|Se?|Oc?|No?|De?)' +
      '|^(J?|F?|M?|A?|S?|O?|N?|D?)',
    'i'
  )
  const match = preformattedValue.match(regex)

  if (match) {
    let result = ''

    if (match[0].length > 5) result = `${formatMonth(match[1])}-${match[2].substring(0, 2)}-${match[2].substring(2)}`
    else if (match[0].length > 3) result = `${formatMonth(match[1])}-${match[2]}`
    else result = formatMonth(match[0])

    return result
  }

  return ''
}

function getFileSize(fileSizeInBytes) {
  if (fileSizeInBytes === null || fileSizeInBytes === undefined || isNaN(fileSizeInBytes)) {
    return '0 B'
  }

  if (fileSizeInBytes < 1024) {
    return fileSizeInBytes + ' B'
  }

  let i = -1
  const byteUnits = [' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB']
  let size = fileSizeInBytes

  while (size >= 1024 && i < byteUnits.length - 1) {
    i++
    size /= 1024
  }

  return size.toFixed(1) + byteUnits[i]
}

function getFileContentType(filename) {
  const regex = /(?:\.([^.]+))?$/
  const extension = regex.exec(filename)[1]

  const contentTypes = {
    pdf: 'application/pdf',
    txt: 'text/plain',
    bmp: 'image/bmp',
    gif: 'image/gif',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
    zip: 'application/zip'
  }

  return contentTypes[extension] || 'application/octet-stream'
}

function calculateLineItemNumTotal({ quantity, price, tax }) {
  const subtotal = quantity * price
  const total = subtotal + subtotal * (tax / 100)
  const finalVal = isNaN(total) ? 0 : total
  return finalVal
}

function calculateLineItemTotal({ quantity, price, tax }) {
  const finalVal = calculateLineItemNumTotal({ quantity, price, tax })
  return finalVal.toFixed(2)
}

function calculateBillTotal({ lineItems = [] }) {
  const total = lineItems.reduce(
    (acc, curr) => (curr.type === 'CHARGE' ? acc + calculateLineItemNumTotal(curr) : acc - calculateLineItemNumTotal(curr)),
    0
  )
  const finalVal = isNaN(total) ? 0 : total
  return finalVal
}

export { formatPostalCode, formatDateInput, getFileSize, getFileContentType, calculateLineItemTotal, calculateBillTotal }
